import { Typography } from '@mui/material'
import { Stack } from '@mui/system'
import { ReleaseResponseDto, ReleaseType } from '@planning/app/api'
import { isValidityExpiredByNow } from '@planning/utils/release-validity-utils'
import { useTranslate } from '@tolgee/react'
import { ColoredLabel, HighlightedText, useMinimalsTheme } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { observer } from 'mobx-react-lite'

interface IProps {
  release: ReleaseResponseDto
  highlight?: string
}

export const ReleaseCard = observer(({ release, highlight }: IProps) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  const typeLabel =
    release.type === ReleaseType.Numeric ? t('numeric', 'Numeric') : t('nonNumeric', 'Non-numeric')

  const validityDayjs = dayjs(release.validityDate)

  const disabledOpacity =
    isValidityExpiredByNow(validityDayjs) ||
    (release.type === ReleaseType.Numeric &&
      release.numericReleaseOpenOrdersAmount !== undefined &&
      release.numericReleaseOpenOrdersAmount <= 0)
      ? 0.5
      : 1

  return (
    <Stack
      direction='row'
      justifyContent='space-between'
      alignItems='center'
      sx={{ width: '100%' }}
    >
      <Stack>
        <Typography variant='body1' sx={{ opacity: disabledOpacity }}>
          <HighlightedText highlight={highlight} color={theme.palette.info.main}>
            {release.referenceNumber}
          </HighlightedText>
        </Typography>
        <Typography variant='caption' color='secondary'>
          {release.shippingLineShortName}
        </Typography>
      </Stack>

      <Stack direction='row' spacing={theme.customSpacing.xs} alignItems='center'>
        {isValidityExpiredByNow(validityDayjs) && (
          <ColoredLabel color='warning' label={t('expired', 'Expired')} />
        )}

        {release.type === ReleaseType.Numeric &&
          release.numericReleaseOpenOrdersAmount !== undefined &&
          release.numericReleaseOpenOrdersAmount <= 0 && (
            <ColoredLabel color='warning' label={t('noOrders', 'No orders')} />
          )}

        <ColoredLabel color='secondary' label={typeLabel} sx={{ opacity: disabledOpacity }} />
      </Stack>
    </Stack>
  )
})
